<div class="container"><br>
  <div class="form-group">
    <label>{{question?.question_copy}}</label>
    <app-question-dropdown
      [showLabel]="false"
      [readOnly]="false"
      [question]="question"
      [selectedValue]="productDetailsId"
      (questionAnswer)="selectChange($event)">
    </app-question-dropdown>
  </div>
</div>
